import React from 'react';
import { ChevronRightIcon } from '../common/Icons';

const ProfileMenuItem = ({ icon, title, badge, onClick }) => {
  return (
    <div 
      className="flex items-center justify-between p-4 border-b"
      onClick={onClick}
    >
      <div className="flex items-center">
        <div className="text-gray-500 mr-3">
          {icon}
        </div>
        <span className="text-lg">{title}</span>
      </div>
      <div className="flex items-center">
        {badge && (
          <div className="bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs mr-2">
            {badge}
          </div>
        )}
        <ChevronRightIcon size={20} className="text-gray-400" />
      </div>
    </div>
  );
};

export default ProfileMenuItem;